module.exports = __webpack_public_path__ + "static/media/coffee-pot.790ab555.svg";